import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { asChakraVariable, keyboardFocusRing } from '@mangovoice/design-system'
import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum IncomingCallButtonVariants {
  Reject = 'reject',
  Accept = 'accept',
  EndAndAccept = 'endAndAccept',
  HoldAndAccept = 'holdAndAccept',
  ParkAndAccept = 'parkAndAccept',
  AcceptWithOverlap = 'acceptWithOverlap',
}

const incomingCallButtonParts = ['button', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(incomingCallButtonParts)

export const IncomingCallButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    button: {
      flexDirection: 'column',
      flexShrink: 0,
      boxSize: '8.75rem',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingY: '1.25rem',
      paddingX: 0,
      backgroundColor: 'bg.panel',
      borderRadius: '0.5rem',
      border: '2px solid',
      borderColor: 'transparent',
      _hover: {
        backgroundColor: 'bg.panel',
        borderColor: 'border.muted',
        boxShadow: asChakraVariable({ default: 'shadows.subtle' }),
      },
      _active: {
        backgroundColor: 'bg.panel',
        borderColor: 'border.muted',
        boxShadow: 'none',
      },
      ...keyboardFocusRing,
    },
    icon: {
      boxSize: '3.75rem',
    },
    text: {
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.default',
    },
  },
})

export const useIncomingCallButtonStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(
    IncomingCallButtonStyle,
    props,
  ) as MultiStyleType<typeof incomingCallButtonParts>
}
